<template>
  <div>
    <Tool>
      <template v-slot:title>
        <h1 class="tool-title-h1">
          用户管理
        </h1>
      </template>
      <template v-slot:content>
        <a-icon type="search" style="color: white; font-size: 20px"/>
        <a-input placeholder="查询账号,用户名..." v-model="queryParam.searchValue" @change="search"
                 style="width: 250px; background-color: transparent; color: white; border: none">
        </a-input>
      </template>
    </Tool>

    <div class="content">
      <div style="margin-bottom: 16px; display: flex; align-items: center;">
        <a-button type="primary" icon="plus-circle" ghost @click="handleAdd">新增</a-button>
      </div>
      <a-table
          rowKey="id"
          :columns="columns"
          :data-source="dataSource"
          :pagination="pagination"
          :loading="loading"
          bordered
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          @change="handleTableChange">
        <template slot="enabled" slot-scope="enabled">
          <a-tag :color="enabled  ? 'green' : 'red'">
            {{ enabled ? "正常" : "停止" }}
          </a-tag>
        </template>
        <template slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定重置密码?" @confirm="() => handleRestPassword(record.id)">
                  <a>重置密码</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </a-table>
    </div>
    <user-create-modal ref="userCreateModal" @ok="loadData"></user-create-modal>
  </div>
</template>

<script>

import Tool from '@/components/Tool.vue'
import {TableMixins} from '@/mixins/table-mixins';
import UserCreateModal from "../components/setting/UserCreateModal";
import debounce from "lodash/debounce";
import {HttpMixins} from "@/mixins/http-mixins";


export default {
  name: "User",
  components: {
    UserCreateModal,
    Tool
  },
  mixins: [HttpMixins, TableMixins],
  data() {
    return {
      queryParam: {
        searchValue: ''
      },
      columns: [
        {
          title: '登陆账号',
          align: "center",
          dataIndex: 'username',
        },
        {
          title: '用户名',
          align: "center",
          dataIndex: 'name',
        },
        {
          title: '欧美填表',
          align: "center",
          dataIndex: 'silverNum'
        },
        {
          title: '东南亚填表',
          align: "center",
          dataIndex: 'bronzeNum'
        },
        {
          title: '签证导出',
          align: "center",
          dataIndex: 'ironNum'
        },
        {
          title: '邮箱',
          align: "center",
          dataIndex: 'email',
        },
        {
          title: '状态',
          align: "center",
          dataIndex: 'enabled',
          scopedSlots: {customRender: 'enabled'}
        },
        {
          title: '备注',
          dataIndex: 'remark',
          align: "center",
        },
        {
          title: '创建时间',
          align: "center",
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {customRender: 'action'},
          align: "center",
        }
      ],
      url: {
        list: window._CONFIG['domainURL'] + "/user/list",
        delete: window._CONFIG['domainURL'] + "/user",
        restPassword: window._CONFIG['domainURL'] + "/user/restPassword",
      }
    };
  },
  methods: {
    search: debounce(function () {
      this.pagination.current = 1;
      this.loadData();
    }, 800),
    handleDelete(id) {
      let that = this;
      that.loading = true;
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.$message.success(response.msg);
            that.loadData();
          } else {
            that.$message.error(response.msg);
          }
        }
      };
      that.$axios.delete(that.url.delete + "?id=" + id, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess))
          .finally(() => {
            that.loading = false;
          });
    },
    handleEdit(record) {
      this.$refs.userCreateModal.edit(record);
    },
    handleAdd() {
      this.$refs.userCreateModal.add();
    },
    handleRestPassword(id) {
      let that = this;
      that.loading = true;
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.$message.success("修改成功,重置密码:123456");
            that.loadData();
          } else {
            that.$message.error(response.msg);
          }
        }
      };
      that.$axios.put(that.url.restPassword, {id: id}, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess))
          .finally(() => {
            that.loading = false;
          })
    }
  },
  created() {
    this.loadData();
  }
}
</script>

<style scoped>

.create-btn.ant-btn:hover, .create-btn.ant-btn:focus {
  color: white;
  background-color: white;
  border-color: white;
}

</style>
